import { FC, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { fetchAsync, postAsync, postWithoutSign } from "../services/ApiHandler";
import { saveToken } from "../services/CookieHandler";
import { Button, Center, Checkbox, Group, Modal, Radio } from "@mantine/core";
import { useHeaderStore } from "./CommonHeader";
import { StripeProduct } from "../model/StripeProduct";
import { StripeCheckoutResponse } from "../model/StripeCheckoutResponse";
export class GenerationCreditDialogProps {
  onPurchase?: () => void;
  onCancel?: () => void;
  onUpgrade?: () => void;
}

export const GenerationCreditDialog: FC<GenerationCreditDialogProps> = ({ onPurchase, onCancel, onUpgrade }) => {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [tosChecked,  setTosChecked] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<StripeProduct | undefined>(undefined);
  const [processing, setProcessing] = useState(false);
  const { remainCount, setRemainCount, fetchRemainCount, subscription, account } = useHeaderStore();
  const [stripeProducts, setStripeProducts] = useState<StripeProduct[]>([]);

  async function fetchStripeProducts() {
    const list = await fetchAsync<StripeProduct[]>('Product/GetProductList');
    setStripeProducts(list.filter(product => product.productType === 'credit').sort((a, b) => a.price - b.price));
  }

  useEffect(() => {
    fetchStripeProducts();
  }, []);


  async function purchase() {
    if(!tosChecked) {
      toast.error("利用規約および料金プランに同意してください");
      return;
    }
    if(selectedProduct === undefined) {
      toast.error("クレジットを選択してください");
      return;
    }

    var checkoutResponse = await fetchAsync<StripeCheckoutResponse>('Stripe/GetCheckoutUrl?isTrial=false&productId=' + selectedProduct.productId);
    window.location.href = checkoutResponse.url;
  }

  async function register(token: String) {
    var param = { AccessToken: token };
    var response = await postWithoutSign<string>('GoogleAuth/Register', param);
    if(response.code === 1) {
      saveToken(response.data!);
      toast.success("ログインしました");
      onPurchase!();
    } else {
      toast.error(response.message!);
    }
  }

  function buildPriceText(product: StripeProduct){
    var isSelected = selectedProduct?.internalProductId === product.internalProductId;
    var backgroundColor = isSelected ? '#FFFFFF' : '#EAEAFF';
    return <div onClick={() => setSelectedProduct(product)} className={`bg-white clickable border rounded-md p-2 w-full ml-4 justify-between flex ${isSelected ? 'border-[#0909FF]' : ''} ${isSelected ?  'bg-[#EAEAFF]' : ''} `}>
      <span className="text-sm font-bold">{product.point} クレジット</span>
      <span className="text-sm font-bold">¥{ product.price.toLocaleString('ja-JP') }</span>
    </div>;
  }

  return <>
    <div className="w-full sm:w-[800px] inline-block justify-center text-primary">
      <div className="text-2xl font-bold text-center">クレジットを追加で購入</div>
      <div className="mt-4 text-sm text-gray-500 text-center">プランのクレジットを使い切っても大丈夫！追加のクレジットを購入いただけます。</div>
      <div className="mt-6">
        <div className="block sm:flex bg-[#F8F9FA] px-8 py-6">
          <div className="w-full sm:w-[50%]">
            <Radio.Group value={selectedProduct?.internalProductId} onChange={(e) => setSelectedProduct(stripeProducts.find(product => product.internalProductId === e))}>
              { stripeProducts.map((e) => (
                <div className="flex justify-between items-center mb-3">
                  <Radio color="#0909FF" value={e.internalProductId}></Radio>
                  { buildPriceText(e) }
                </div>
              ))}
            </Radio.Group>
          </div>
          <div className="w-full sm:w-[50%] items-center justify-center px-6">
            <div className="flex justify-center mt-8">
              <Checkbox
                color="#0909FF"
                checked={tosChecked}
                label="利用規約および料金プランに同意する"
                onChange={(event) => setTosChecked(event.currentTarget.checked)}
              />
              </div>
              <div className="mt-4">
                <Button className="gradation-button" style={{fontWeight: '700'}} onClick={purchase} disabled={ processing } justify="center" fullWidth>クレジットを購入する</Button>
              </div>
              { (subscription?.internalProductId === 'free' || subscription?.internalProductId.startsWith('lite') || subscription?.internalProductId.startsWith('standard')) &&
                <>
                <div className="bg-gray-200 h-[1px] w-full mt-6"></div>
                <div className="text-center text-sm mt-[-10px]">
                  <span className="bg-[#F8F9FA] px-4 text-sm text-gray-500">または</span>
                </div>
                <div className="mt-4">
                  <Button onClick={() => onUpgrade!()} justify="center" fullWidth variant="default">+ プランをアップグレードする</Button>
                </div>
                </>
              }
          </div>
        </div>
      </div>
    </div>
  </>;

}